import { ascend, descend, prop, sortWith } from 'ramda';

export const SORT_NAME_ASC = 'SORT_NAME_ASC';
export const SORT_NAME_DESC = 'SORT_NAME_DESC';
export const SORT_DATE_ASC = 'SORT_DATE_ASC';
export const SORT_DATE_DESC = 'SORT_DATE_DESC';
export const SORT_SIZE_ASC = 'SORT_SIZE_ASC';
export const SORT_SIZE_DESC = 'SORT_SIZE_DESC';

const prefixesSorting = {
    [SORT_NAME_ASC]: sortWith([ascend(prop('Prefix'))]),
    [SORT_NAME_DESC]: sortWith([descend(prop('Prefix'))]),
};

const contentsSorting = {
    [SORT_NAME_ASC]: sortWith([ascend(prop('Key'))]),
    [SORT_NAME_DESC]: sortWith([descend(prop('Key'))]),
    [SORT_DATE_ASC]: sortWith([ascend(prop('LastModified'))]),
    [SORT_DATE_DESC]: sortWith([descend(prop('LastModified'))]),
    [SORT_SIZE_ASC]: sortWith([ascend(prop('Size'))]),
    [SORT_SIZE_DESC]: sortWith([descend(prop('Size'))]),
};

export function sortPrefixes(prefixes, type) {
    const sort = prefixesSorting[type] || prefixesSorting[SORT_NAME_ASC];

    return sort(prefixes);
}

export function sortContents(contents, type) {
    return contentsSorting[type](contents);
}
